import { useSearchParams } from 'react-router-dom'
import ax, { SEARCH, SEARCH_WORDS, SEARCH_OPTIONS } from '%/axios';
import { useState } from 'react';
import conso from '%/conso';
import * as uf from '%/functions';
const init = {
  products: [],
  categories: [],
  product_options: {},
  total: 0,
  numPages: 1,
}
const initAutocomplete = {

}


const useSearch = () => {
  // let [searchParams, setSearchParams] = useSearchParams();


  // const handleSearchUrl = (search = '') => {
  //   setSearchParams({ search })
  // }
  const [searchResults, setSearchResults] = useState(init);
  const [autocomplete, setAutocomplete] = useState([])
  const [search, setSearch] = useState(QUERY_STRING ?? '');

  const handleSearch = async () => {
    const str = document.querySelector('#search_query').value
    if (str.length < 2) return;
    setSearchResults(prev => ({
      ...prev,
      product_options: {}
    }))
    try {
      const res = await handleSearchAPI(str);
      if (res) {
        const categories = uf.determineCategories(res.products);
        setSearchResults(prev => ({
          ...prev,
          products: res.products,
          categories,
          product_options: res.products.reduce((acc, each) => {
            each.product_options?.forEach(item => {
              if(item.name === 'Please Note')
               return;
              if (!acc[item?.name]) {
                acc[item.name] = [item.description]
              } else
                acc[item.name].concat(item.description);

            })

            return acc;
          }, {}),
          count: res.count
        }))
      }
    } catch (er) {
      conso.trace(er);
    }
    handleSearchAutocompleteAPI(str);
  }

  const setSearchResultsPagesTotal = (data) => {
    // setSearchResults(prev => ({
    //   ...prev,
    //   products: data.items,
    //   total: data.total,
    //   numPages: data.numPages,
    // }))
  }


  const handleSearchCustomOptionAPI = async (str) => {
    try {
      if (!str) return;
      const res = await ax(SEARCH_OPTIONS, { qs: str });
      if (res)
        setSearchResults(prev => ({
          ...prev,
          product_options: {
            ...prev.product_options,
            [str]: res
          }
        }))
    } catch (er) {
      conso.trace(er);
    }
  }

  const handleSearchAutocompleteAPI = async (str) => {
    try {
      const res = await ax(SEARCH_WORDS, { qs: str })
      if (res) {
        setAutocomplete(res);
      }
      return
    } catch (er) {
      conso.trace(er);
      setAutocomplete([])
    }
  }

  const handleSearchAPI = async (qs, categoryIds = []) => {
    const res = await ax(SEARCH, {
      filters: {
        categoryIds
      },
      qs,
      // showHidden: true
    });

    return res;
  }

  return {
    // handleSearchUrl,
    handleSearchAPI,
    searchResults,
    setSearchResults,
    handleSearch,
    autocomplete,
    setAutocomplete,
    search,
    setSearch,
    handleSearchCustomOptionAPI,
    setSearchResultsPagesTotal
  }
}
export default useSearch;